import { render } from "./Title1.vue?vue&type=template&id=1675aa78"
import script from "./Title1.vue?vue&type=script&lang=ts"
export * from "./Title1.vue?vue&type=script&lang=ts"

import "./Title1.vue?vue&type=style&index=0&id=1675aa78&lang=scss"
script.render = render

export default script